import FieldBlock from "../../components/CreateClaim/FieldBlock";
import { useFormContext } from "react-hook-form";
import { FiEye, FiFile } from "react-icons/fi";

function NikonReviewClaimRequest() {
  const { getValues } = useFormContext();

  const data = getValues();

  const handleViewFile = (url: string) => {
    if (url) {
      window.open(url, "_blank");
    }
  };

  return (
    <div className="space-y-4">
      <div className="bg-[#F3F8FE] bg-opacity-80 min-h-8 p-4 border border-gray-300 rounded-lg">
        <div className="text-black font-semibold">Purchase Details</div>
        <div className="space-y-2 mt-2">
          <FieldBlock
            label="Name on the invoice"
            value={data?.purchase_info?.name_on_invoice}
          />
          <FieldBlock
            label="Invoice number"
            value={data?.purchase_info?.invoice_number}
          />
          <FieldBlock
            label="Date of Purchase"
            value={data?.purchase_info?.date_of_purchase}
            date
          />

          {data?.purchase_info?.uploaded_invoice_url && (
            <div className="pt-2">
              <label className="text-sm text-gray-600 block mb-1">
                Uploaded Invoice/Receipt
              </label>
              <div className="border border-green-200 bg-green-50 rounded-lg p-3 flex items-center justify-between">
                <div className="flex items-center gap-2 flex-1 min-w-0">
                  <FiFile className="text-green-600 flex-shrink-0" size={20} />
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-green-800 truncate">
                      Invoice Document
                    </p>
                    <p className="text-xs text-green-600">
                      Click to view uploaded file
                    </p>
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() =>
                    handleViewFile(data?.purchase_info?.uploaded_invoice_url)
                  }
                  className="p-2 hover:bg-green-100 rounded-lg transition-colors"
                  title="View file"
                >
                  <FiEye className="text-green-700" size={18} />
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="bg-[#F3F8FE] bg-opacity-80 min-h-8 p-4 border border-gray-300 rounded-lg">
        <div className="text-black font-semibold">Customer Details</div>
        <div className="space-y-2 mt-2">
          <FieldBlock label="Customer Name" value={data?.customer_info?.name} />
          <FieldBlock
            label="Customer Email"
            value={data?.customer_info?.email}
          />
          <FieldBlock
            label="Customer Phone"
            value={data?.customer_info?.phone}
          />
          <FieldBlock
            label="Customer Address"
            value={data?.customer_info?.address}
          />
          <FieldBlock label="City" value={data?.customer_info?.city} />
          <FieldBlock label="State" value={data?.customer_info?.state} />
          <FieldBlock label="Zip code" value={data?.customer_info?.zip_code} />
        </div>
      </div>

      <div className="bg-[#F3F8FE] bg-opacity-80 min-h-8 p-4 border border-gray-300 rounded-lg">
        <div className="text-black font-semibold">Store Details</div>
        <div className="space-y-2 mt-2">
          <FieldBlock label="Store Name" value={data?.store_info?.name} />
          <FieldBlock label="Store Phone" value={data?.store_info?.phone} />
          <FieldBlock label="Store Address" value={data?.store_info?.address} />
          <FieldBlock label="Store City" value={data?.store_info?.city} />
          <FieldBlock label="Store State" value={data?.store_info?.state} />
          <FieldBlock label="Zip" value={data?.store_info?.zip} />
          <FieldBlock
            label="Were any items exchanged"
            value={data?.store_info?.items_exchanged}
          />
        </div>
      </div>

      {data?.damage?.map((item, index) => (
        <div key={index}>
          <div className="bg-[#EBEEEF] text-black font-semibold min-h-8 rounded flex items-center px-2 gap-2">
            {`Damage ${index + 1}`}
          </div>
          <div className="bg-white grid gap-1.5 divide-y divide-[#F0F0F0] px-2 py-2">
            <FieldBlock label="Product" value={item?.product} />
            <FieldBlock label="Model Number" value={item?.model_number} />
            <FieldBlock label="Serial Number" value={item?.serial_number} />
            <FieldBlock label="Complaint" value={item?.complaint} />
            <FieldBlock
              label="Date of Damage/Discovery"
              value={item?.date_of_damage}
              date
            />
            <FieldBlock label="Cause" value={item?.cause} />
            <FieldBlock label="Customer Action" value={item?.customer_action} />
            <FieldBlock
              label="Who currently has possession of the damaged item?"
              value={item?.item_possession_status}
            />
            {(item?.item_possession_status === "Retailer" ||
              item?.item_possession_status === "Nikon") && (
              <>
                <FieldBlock
                  label="Service Order Number"
                  value={item?.service_order_number}
                />
                <FieldBlock
                  label="Reference Number"
                  value={item?.reference_number}
                />
              </>
            )}
            <FieldBlock label="Description" value={item?.description} />
          </div>
        </div>
      ))}
    </div>
  );
}

export default NikonReviewClaimRequest;
